import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import PropTypes from "prop-types";
import "./PlaceholderSimpleEmptyScreen.scss";

const PlaceholderSimpleEmptyScreen = ({
    Image,
    TextFirstLine,
    TextSecondLine,
}) => {
    return (
        <Container className="placeholder-simple-empty-screen">
            <Row>
                <Col>
                    <Row style={{justifyContent:"center"}}>
                        <div className="image-container">
                            {   Image &&
                                <img className="hero-image" src={Image} alt="Empty Screen"/>
                            }
                        </div>
                    </Row>
                    <Row style={{justifyContent:"center"}}>
                        <div className="screen-body-content">
                            {TextFirstLine ?? ""}
                            {<br/>}
                            {TextSecondLine ?? ""}
                        </div>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

PlaceholderSimpleEmptyScreen.propTypes = {
    Image: PropTypes.string,
    TextFirstLine: PropTypes.string,
    TextSecondLine: PropTypes.string,
}

export default PlaceholderSimpleEmptyScreen;
